$(document).ready(function() {
  var currentTab_events = localStorage.getItem("active_tab_events");
  var currentTab_tarifs = localStorage.getItem("active_tab_tarifs");

  var defaultTab = $(".tab-link.current").attr("data-tab");
  var tab_id_events = defaultTab;
  var tab_id_tarifs = defaultTab;

  if (currentTab_events != null) var tab_id_events = currentTab_events;
  if (currentTab_tarifs != null) var tab_id_tarifs = currentTab_tarifs;

  $(".submenu .tarifs-item a").click(function(e) {
    localStorage.removeItem("active_tab_tarifs");
    var tab_id_tarifs = $(this).attr("data-tab");
    localStorage.setItem("active_tab_tarifs", tab_id_tarifs);
  });

  $(".submenu .event-item a").click(function(e) {
    localStorage.removeItem("active_tab_events");
    var tab_id_events = $(this).attr("data-tab");
    localStorage.setItem("active_tab_events", tab_id_events);
  });

  if ($("body").hasClass("page-template-template-events")) {
    localStorage.removeItem("active_tab_tarifs");
    location.hash = tab_id_events;
    $(".tab-content-events").removeClass("current");
    $("#" + tab_id_events).addClass("current");

    $(".tab-content-events:visible")
      .fadeOut(300)
      .queue(function(nxt) {
        $(".tab-content-events.current .gallery").hide();
        $(".tab-content-events.current")
          .fadeIn(300)
          .queue(function(nxt) {
            $(".tab-content-events.current .gallery").show();
            nxt();
          });
        nxt();
      });

    $("ul.tabs-events li").removeClass("current");
    $("ul.tabs-events li[data-tab=" + tab_id_events).addClass("current");
  } else {
    localStorage.removeItem("active_tab_events");
  }

  if ($("body").hasClass("page-template-template-tarifs")) {
    localStorage.removeItem("active_tab_events");
    location.hash = tab_id_tarifs;
    $(".tab-content-tarifs").removeClass("current");

    $(".tab-content-tarifs:visible")
      .fadeOut(300)
      .queue(function(nxt) {
        $(".tab-content-tarifs.current").fadeIn(300);
        nxt();
      });

    $("ul.tabs-tarifs li").removeClass("current");
    $("ul.tabs-tarifs li[data-tab=" + tab_id_tarifs).addClass("current");
  } else {
    localStorage.removeItem("active_tab_tarifs");
  }

  $(".tab-contents").hide();
  $(".tab-content.current").show();

  $("ul.tabs li").click(function(e) {
    e.preventDefault();
    var tab_id = $(this).attr("data-tab");
    $("ul.tabs li").removeClass("current");
    $(".tab-content").removeClass("current");
    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
    // $(".tab-content").hide();
    // $(".tab-content.current").slideDown();
  });

  $(".tab-content-tarifs").hide();
  $(".tab-content-tarifs.current").show();
  $("ul.tabs-tarifs li").click(function(e) {
    e.preventDefault();
    localStorage.removeItem("active_tab_tarifs");
    var tab_id = $(this).attr("data-tab");
    localStorage.setItem("active_tab_tarifs", tab_id);
    location.hash = tab_id;

    $("ul.tabs-tarifs li").removeClass("current");
    $(".tab-content-tarifs").removeClass("current");
    $(this).addClass("current");
    $("#" + tab_id).addClass("current");

    $(".tab-content-tarifs:visible")
      .fadeOut(300)
      .queue(function(nxt) {
        $(".tab-content-tarifs.current").fadeIn(300);
        nxt();
      });
  });
  $(".tab-content-events").hide();
  $(".tab-content-events.current").show();

  $("ul.tabs-events li").click(function(e) {
    e.preventDefault();
    localStorage.removeItem("active_tab_events");
    var tab_id = $(this).attr("data-tab");
    localStorage.setItem("active_tab_events", tab_id);
    location.hash = tab_id;
    $("ul.tabs-events li").removeClass("current");
    $(".tab-content-events").removeClass("current");
    $(this).addClass("current");
    $("#" + tab_id).addClass("current");

    $(".tab-content-events:visible")
      .fadeOut(300)
      .queue(function(nxt) {
        $(".tab-content-events.current .gallery").hide();
        $(".tab-content-events.current")
          .fadeIn(300)
          .queue(function(nxt) {
            $(".tab-content-events.current .gallery").show();
            nxt();
          });
        nxt();
      });
  });

  if (location.hash) {
    // alert('hash' + location.hash);
    // $('.tab-content-events').removeClass('current');

    $("ul.tabs-events li").removeClass("current");

    $(".tab-content-events").each(function() {
      $("section.tab-content-events" + location.hash).addClass("current");
      $("ul.tabs-events li[data-tab=" + location.hash.substr(1) + "]").addClass(
        "current"
      );
    });

    $(".tab-content-events.current").fadeIn(300);

    $(".tab-content-tarifs").hide();

    $("ul.tabs-tarifs li").removeClass("current");
    $(".tab-content-tarifs").removeClass("current");
    $(".tab-content-tarifs").each(function() {
      $(".tab-content-tarifs" + location.hash).addClass("current");
      $("ul.tabs-tarifs li[data-tab=" + location.hash.substr(1) + "]").addClass(
        "current"
      );
    });
    $(".tab-content-tarifs").fadeOut(300);
    $(".tab-content-tarifs.current").fadeIn(300);
  }
  if ($("body").hasClass("page-template-template-tarifs")) {
    $(".submenu .tarifs-item a").click(function(e) {
      e.preventDefault();
      $(".submenu").removeClass("open");

      $(".tab-content-tarifs").removeClass("current");
      var tab_id_tarifs = $(this).attr("data-tab");

      location.hash = tab_id_tarifs;
      $("#" + tab_id_tarifs).addClass("current");
      $(".tab-content-tarifs").fadeOut(300);
      $(".tab-content-tarifs.current").fadeIn(300);
      $("ul.tabs-tarifs li").removeClass("current");
      $("ul.tabs-tarifs li[data-tab=" + tab_id_tarifs).addClass("current");
    });
  }
  if ($("body").hasClass("page-template-template-events")) {
    $(".submenu .event-item a").click(function(e) {
      e.preventDefault();
      $(".submenu").removeClass("open");
      $(".tab-content-events").removeClass("current");
      $(".tab-content-tarifs").removeClass("current");
      var tab_id_events = $(this).attr("data-tab");

      location.hash = tab_id_events;
      $("#" + tab_id_events).addClass("current");

      $(".tab-content-events.current .gallery").hide();

      $(".tab-content-events:visible")
        .fadeOut(300)
        .queue(function(nxt) {
          $(".tab-content-events.current .gallery").hide();
          $(".tab-content-events.current")
            .fadeIn(300)
            .queue(function(nxt) {
              $(".tab-content-events.current .gallery").show();
              nxt();
            });
          nxt();
        });
      $("ul.tabs-events li").removeClass("current");
      $("ul.tabs-events li[data-tab=" + tab_id_events).addClass("current");
    });
  }
});
